module.exports = __webpack_public_path__ + "img/roulette-clubs.e2ba301f.svg";